import baseApi from '@store/api/baseApi';

export const costingAgentApi = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		getCostingByProductId: builder.query({
			query: ({ productId, brandName, singleQty, supplierName, isBuyerRequest, initialCostingId }) => {
				const params = [];
				if (brandName) params.push(`brandName=${brandName}`);
				if (singleQty) params.push(`quantity=${singleQty}`);
				if (supplierName) params.push(`supplierName=${supplierName}`);
				if (isBuyerRequest !== undefined) params.push(`isBuyerRequest=${isBuyerRequest}`);
				if (initialCostingId) params.push(`initialCostingId=${initialCostingId}`);
				const queryString = params.length ? `?${params.join('&')}` : '';
				return `/product/predict-cost/${productId}${queryString}`;
			},
			providesTags: ['Costing']
		}),
		getHistoryByProductId: builder.query({
			query: ({ productId, brandId, initialCostingId }) => {
				const params = [];
				if (brandId) params.push(`brandId=${brandId}`);
				if (initialCostingId) params.push(`initialCostingId=${initialCostingId}`);
				const queryString = params.length ? `?${params.join('&')}` : '';
				return `/product/predict-cost/history/${productId}${queryString}`;
			},
			providesTags: ['History']
		}),
		getPriceRangeByProductId: builder.query({
			query: (productId) => `/product/price-range/${productId}`,
			providesTags: ['PriceRange']
		}),
		getProductInfoByProductId: builder.query({
			query: (productId) => `/product/design-info/${productId}?checkBuyerSelectionStatus=true`,
			providesTags: ['ProductInfo']
		}),
		submitCosting: builder.mutation({
			query: ({ productId, historyId, requestBody, initialCostingId }) => ({
				url: `/product/save/predict-cost/${productId}/history/${historyId}${initialCostingId ? `?initialCostingId=${initialCostingId}` : ''}`,
				method: 'POST',
				body: requestBody
			}),
			invalidatesTags: ['History']
		}),
		handleRecost: builder.mutation({
			query: ({
				productId,
				historyId,
				requestBody,
				brandName,
				singleQty,
				supplierName,
				isBuyerRequest,
				initialCostingId
			}) => {
				const params = [];
				if (brandName) params.push(`brandName=${brandName}`);
				if (singleQty) params.push(`quantity=${singleQty}`);
				if (supplierName) params.push(`supplierName=${supplierName}`);
				if (isBuyerRequest !== undefined) params.push(`isBuyerRequest=${isBuyerRequest}`);
				if (initialCostingId) params.push(`initialCostingId=${initialCostingId}`);
				const queryString = params.length ? `?${params.join('&')}` : '';
				return {
					url: `/product/re-cost/${productId}/history/${historyId}${queryString}`,
					method: 'POST',
					body: requestBody
				};
			},
			invalidatesTags: ['History']
		}),
		getCostingByHistoryId: builder.query({
			query: ({ productId, historyId }) => `/product/predict-cost/${productId}/history/${historyId}`,
			providesTags: ['Costing']
		}),
		likeUnlikeCosting: builder.query({
			query: ({ productId, historyId, isLiked }) =>
				`/product/predict-cost/${productId}/history/${historyId}/isLiked?isLiked=${isLiked}`,
			providesTags: ['Costing']
		}),
		brandWiseSupplier: builder.query({
			query: ({ brand }) => `/product/get-brand-wise-suppliers?brandName=${brand}`,
			providesTags: ['BrandWiseSupplier']
		})
	})
});

export const {
	useGetCostingByProductIdQuery,
	useGetHistoryByProductIdQuery,
	useSubmitCostingMutation,
	useHandleRecostMutation,
	useGetCostingByHistoryIdQuery,
	useLikeUnlikeCostingQuery,
	useLazyLikeUnlikeCostingQuery,
	useGetPriceRangeByProductIdQuery,
	useGetProductInfoByProductIdQuery,
	useBrandWiseSupplierQuery
} = costingAgentApi;
